import { Link } from "react-router-dom";

// material-ui
import { useTheme, styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";

// project imports

// assets
import BG from "assets/images/maintenance/404.png";

// styles

// ==============================|| ERROR PAGE ||============================== //

const Error = () => {
  const theme = useTheme();

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      position="relative"
      width={"100%"}
      height={"100vh"}
      sx={{ background: `no-repeat center/100% url(${BG}),#293642` }}
    ></Grid>
  );
};

export default Error;
